import React, { Component } from 'react'
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import {GoogleToken, GoogleUserId } from '../utils/util-networkCalls.js';
import * as Sentry from "@sentry/react";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const SCOPES = 'https://www.googleapis.com/auth/tagmanager.readonly';
const CLIENT_SECRET = process.env.REACT_APP_GOOGLE_SECRET;


class GoogleBtn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogined: false,
      accessToken: ''
    };

    this.login = this.login.bind(this);
    this.handleLoginFailure = this.handleLoginFailure.bind(this);
    this.logout = this.logout.bind(this);
    this.handleLogoutFailure = this.handleLogoutFailure.bind(this);
  }

  login (response) {
  //  console.log('successful login');
    if(response.code){
      // Gets Tokens from Auth Code
      //console.log('Response')
      //console.log(response);
      GoogleToken(response.code, CLIENT_ID, CLIENT_SECRET).then(authResponse =>{
        //console.log('Auth Response');
        //console.log(authResponse);

        // Gets user Details
        GoogleUserId(authResponse.id_token).then(userDetails =>{
          //console.log('user Details')
          //console.log(userDetails)

          this.setState(state => ({
            isLogined: true,
            googleAccessToken: authResponse.access_token,
            googleRefreshToken: authResponse.refresh_token,
            email: userDetails.email,
            name: userDetails.name,
            firstName: userDetails.given_name,
            lastName: userDetails.family_name,
            locale: userDetails.locale,
            googleUserId: userDetails.sub
          }));
          //console.log(this.state);
          this.props.googleAccessToken(this.state);
        }).catch(error=>{
          Sentry.captureMessage("User Detail Error");
          Sentry.captureException(error);

    //      console.log('userDetails')
    //      console.log(error);
        });
      }).catch(error=>{
        Sentry.captureMessage("User Authorization Error");
        Sentry.captureException(error);

    //    console.log('AuthResponse')
    //    console.log(error);
      })
    }
  }

  logout (response) {
   // console.log('successful logout');
    this.setState(state => ({
      isLogined: false,
      accessToken: ''
    }));
    this.props.loggedOut();
  }

  handleLoginFailure (response) {
    Sentry.captureMessage("Google Login Failure");
    Sentry.captureException(response);
    console.log('Failed to log in')
    console.log(response)
  }

  handleLogoutFailure (response) {
    Sentry.captureMessage("Google Logout Failure");
    Sentry.captureException(response);
    console.log('Failed to log out')
  }

  render() {
    return (
    <div>
      { this.props.isLogined ?
        <GoogleLogout
          clientId={ CLIENT_ID }
          buttonText='Logout'
          onLogoutSuccess={ this.logout }
          onFailure={ this.handleLogoutFailure }
        >
        </GoogleLogout>: <GoogleLogin
          clientId={CLIENT_ID}
          scope={SCOPES}
          buttonText= {this.props.label}
          onSuccess={ this.login }
          onFailure={ this.handleLoginFailure }
          cookiePolicy={ 'single_host_origin' }
          responseType='code'
          accessType='offline'
          approvalPrompt="force"
          prompt='consent'
        />
      }
    </div>
    )
  }
}

export default GoogleBtn;
